import { ProductService } from '@debbie/common/dist/connect/products/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from '../../Select.js';
const ProductServiceSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Select, { title: lang.connect.service, searchThreshold: 8, options: [
            {
                value: ProductService.Collection,
                label: lang.connect.serviceCollection,
            },
            {
                value: ProductService.CourtHandling,
                label: lang.connect.serviceCourtHandling,
            },
        ], selected: [props.value], onChange: (selected) => {
            const service = Object.values(ProductService).find((value) => value === selected[0]);
            if (service !== undefined) {
                props.onChange(service);
            }
        } }));
};
export default ProductServiceSelect;
//# sourceMappingURL=ProductServiceSelect.js.map